export default __webpack_public_path__ + "static/media/Kuthcheman War Blade.94f6a171.jpg";